import {
    FormArray,
    FormArrayProps,
    FormInput
} from '@auviknetworks/iceberg-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

export type FormKeyValueProps = Omit<FormArrayProps, 'children'>;

export const FormKeyValue = (props: FormKeyValueProps) => {
    const { t } = useTranslation();
    return (
        <FormArray {...props}>
            <FormInput label={t('Common.label')} name="label" />
            <FormInput label={t('Common.value')} name="value" />
        </FormArray>
    );
};
